import { confirmAlert } from 'react-confirm-alert';

import type { ConfirmUserBlockProps } from '../types';
import { UserBlockConfirmation } from './UserBlockConfirmation';

export function confirmUserBlock({
  userId,
  onConfirm,
  onReject,
}: ConfirmUserBlockProps): void {
  confirmAlert({
    onClickOutside: () => onReject?.(),
    onKeypressEscape: () => onReject?.(),
    customUI: ({ onClose }) => {
      return (
        <UserBlockConfirmation
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
          userId={userId}
        />
      );
    },
  });
}
